import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { style } from 'constant/constants';

const Text = ({ variant, children, sx, ...props }) => (
  <Typography variant={variant} {...props} sx={[{ fontFamily: style.fontFamily }, sx]}>
    {children}
  </Typography>
);

Text.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.object
};

export default Text;
